import React from "react";
import { motion } from "framer-motion";
import { BASE_UPLOADS } from "../../../utils/constants";
import { Link } from "react-router-dom";

function CategoryCard({ category }) {
	return (
		<motion.div
			initial={{ opacity: 0, y: 50 }}
			whileInView={{ opacity: 1, y: 0 }}
			transition={{ duration: 0.7 }}
			className="w-full lg:w-[17rem] h-full bg-white flex flex-col justify-between overflow-hidden"
		>
			<div className="relative">
				<img
					src={
						category.image
							? `${BASE_UPLOADS}/category-pic/${category.image}`
							: "./images/coding.jpg"
					}
					alt={category.category}
					className="w-full h-48 object-cover rounded-xl"
				/>
			</div>
			<div className="py-6">
				<h1 className="text-black font-medium text-base mb-2 capitalize">
					{category.title}
				</h1>
				<p className="text-gray-500 text-xs line-clamp-3">
					{category.description}
				</p>
			</div>

			<Link to={"/enroll"}>
				<button className="bg-white w-full text-black py-3 text-sm border border-gray-400 rounded-full hover:bg-mainColor hover:border-mainColor hover:border-opacity-80 hover:bg-opacity-80 hover:text-white transition duration-500">
					Get Started
				</button>
			</Link>
		</motion.div>
	);
}

export default CategoryCard;
